export interface SpotifyArtistCredit {
  id?: string;
  name?: string;
}

export interface SpotifyAlbumArtistCredit {
  album_group?: string;
  artists?: SpotifyArtistCredit[];
}

export interface SpotifyTrackArtistCredit {
  artists?: SpotifyArtistCredit[];
}

export const normalizeSpotifyArtistCredit = (value?: string | null) => {
  return (value || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
};

export const hasSpotifyArtistCredit = (
  item: SpotifyAlbumArtistCredit | SpotifyTrackArtistCredit | null | undefined,
  artistName?: string | null,
  artistId?: string | null
) => {
  const normalizedArtistName = normalizeSpotifyArtistCredit(artistName);
  const normalizedArtistId = artistId || "";

  if (!item?.artists?.length || (!normalizedArtistName && !normalizedArtistId)) return false;

  return item.artists.some((artist) => {
    const creditName = normalizeSpotifyArtistCredit(artist.name);
    return (
      (normalizedArtistName && creditName === normalizedArtistName) ||
      (normalizedArtistId && artist.id === normalizedArtistId)
    );
  });
};

export const shouldIncludeSpotifyTrackForArtist = (
  album: SpotifyAlbumArtistCredit | null | undefined,
  track: SpotifyTrackArtistCredit | null | undefined,
  artistName?: string | null,
  artistId?: string | null
) => {
  const albumGroup = (album?.album_group || "").toLowerCase();
  const trackHasArtistCredit = hasSpotifyArtistCredit(track, artistName, artistId);

  if (albumGroup === "appears_on" || albumGroup === "compilation") {
    return trackHasArtistCredit;
  }

  return trackHasArtistCredit || hasSpotifyArtistCredit(album, artistName, artistId);
};

export const filterSpotifyAlbumTracksForArtist = <Track extends SpotifyTrackArtistCredit>(
  album: SpotifyAlbumArtistCredit | null | undefined,
  tracks: Track[],
  artistName?: string | null,
  artistId?: string | null
) => {
  return tracks.filter((track) => shouldIncludeSpotifyTrackForArtist(album, track, artistName, artistId));
};
